import { CalendarDays, LayoutDashboard, List } from 'lucide-react';
import { Row } from '../../lib/utils';
import { colors } from '../../lib/colors';
import { ScheduleViewMode } from './scheduleViewPreferences';

type ScheduleViewSwitcherProps = {
    viewMode: ScheduleViewMode;
    onChange: (viewMode: ScheduleViewMode) => void;
};

const VIEW_OPTIONS = [
    { value: 'smart' as const, label: '한눈에', icon: LayoutDashboard },
    { value: 'calendar' as const, label: '기존 캘린더', icon: CalendarDays },
    { value: 'list' as const, label: '목록', icon: List },
];

const ScheduleViewSwitcher = ({ viewMode, onChange }: ScheduleViewSwitcherProps) => (
    <Row
        role="group"
        aria-label="스케줄 보기"
        style={{
            display: 'inline-flex',
            height: 36,
            padding: 3,
            boxSizing: 'border-box',
            borderRadius: 10,
            border: '1px solid #C3D4F4',
            backgroundColor: '#F8FBFF',
            alignItems: 'center',
            boxShadow: '0 3px 10px rgba(32, 54, 92, 0.08)',
            flex: '0 0 auto',
        }}
    >
        {VIEW_OPTIONS.map(({ value, label, icon: Icon }) => {
            const isActive = viewMode === value;
            return (
                <button
                    key={value}
                    type="button"
                    aria-pressed={isActive}
                    onClick={() => onChange(value)}
                    style={{
                        height: 28,
                        padding: '0 8px',
                        borderRadius: 7,
                        border: 'none',
                        backgroundColor: isActive ? colors.BLUE_500 : 'transparent',
                        color: isActive ? '#FFFFFF' : colors.BLUE_500,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 4,
                        fontSize: 12,
                        fontWeight: 700,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        flexShrink: 0,
                    }}
                >
                    <Icon size={14} strokeWidth={2.2} aria-hidden="true" />
                    {label}
                </button>
            );
        })}
    </Row>
);

export default ScheduleViewSwitcher;
